import { render } from "./CoReg_submit.vue?vue&type=template&id=34d2a422&scoped=true"
import script from "./CoReg_submit.vue?vue&type=script&lang=js"
export * from "./CoReg_submit.vue?vue&type=script&lang=js"

import "./CoReg_submit.vue?vue&type=style&index=0&id=34d2a422&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d2a422"]])

export default __exports__